import './styles.css';

import React from 'react';
import classname from '@search/classname/src';

interface LinkSnippetProps {
    target?: string;
    underline?: boolean;
    fullWidth?: boolean;
    withoutHover?: boolean;
    to: string;
    className?: string;
    children: React.ReactNode;
    isActive?: boolean;
    isVisited?: boolean | null;
    dataGtm?: Record<string, string>;
    dataTest?: string;
    handleClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
}

const defaultClick = () => {};

export function LinkSnippet({
    target = '_blank',
    underline = false,
    fullWidth,
    className,
    isVisited = false,
    withoutHover = false,
    to,
    children,
    dataGtm = {},
    isActive,
    dataTest,
    handleClick = defaultClick
}: LinkSnippetProps) {
    return (
        <a
            href={to}
            target={target}
            className={classname('LinkSnippet', null, { visited: isVisited ?? false, underline, active: isActive, fullWidth, hover: ! withoutHover }, className)}
            onClick={handleClick}
            data-test={dataTest}
            {...dataGtm}
        >{children}</a>
    );
}
